<div class="custom-toolbar">
  <div class="custom-toolbar-element custom-toolbar-subdivision-left custom-button-container">
    <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
    <yo-button
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.DEFAULT"
      label="CRÉER"
      tooltip="Créer un modèle de plat"
      (onClick)="openModelePlat(null)"
      [disabled]="!canCreateAndDelete()">
    </yo-button>
    <yo-button
      iconClass="fas fa-toolbox"
      [theme]="ButtonThemeEnum.DEFAULT"
      (onClick)="openGlobalConditionnementSettings()"
      [disabled]="!canCreateAndDelete()"
      tooltip="Règles de réduction du nombre de contenants">
    </yo-button>
  </div>
  <div class="custom-toolbar-subdivision-left custom-button-container">
    <yo-button
      iconClass="fas fa-trash"
      [theme]="ButtonThemeEnum.DELETE"
      (onClick)="delete()"
      [disabled]="!canCreateAndDelete() || !selectedRows.length"
      tooltip="Supprimer les éléments sélectionnés">
    </yo-button>
  </div>
</div>

<dx-data-grid
  [dataSource]="modelesPlatsList"
  keyExpr="id"
  [height]="utilsSvc.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  #grid>
  <dxo-selection
    [selectAllMode]="allMode"
    [showCheckBoxesMode]="checkBoxesMode"
    mode="multiple"
  ></dxo-selection>
  <dxi-column dataField="id" caption="Actions"
              [width]="100"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="site" caption="Site" cellTemplate="actionsSiteTemplate"
              [calculateCellValue]="calculateSiteValue" [filterOperations]="['contains']"
              [allowFiltering]="true" width="300"></dxi-column>
  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="interne" caption="Type" cellTemplate="typeModeleTemplate"
              [calculateCellValue]="calculateTypeModeleValue"
              [allowFiltering]="true" width="140">
    <dxo-lookup [dataSource]="typeModeleOptions" displayExpr="libelle" valueExpr="value"></dxo-lookup>
  </dxi-column>


  <!--  ACTIONS CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">

    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openModelePlat(cell.row.data)"
                    [iconClass]="canModify(cell.row.data)?'fa fa-edit':'fas fa-eye'"
                    [tooltip]="canModify(cell.row.data)?'Modifier le modèle':'Voir le modèle'">
    </yo-button>

    <yo-button size="small"
                    [theme]="ButtonThemeEnum.SECONDARY_INNER" (onClick)="openPanelDuplication($event, cell.row.data)"
                    iconClass="fa fa-copy"
                    [tooltip]="'Dupliquer le modèle de plat '+ cell.row.data.libelle"
    ></yo-button>

  </div>

  <div *dxTemplate="let cell of 'actionsSiteTemplate'">
    <yo-site [siteLibelle]="cell.row.data?.site?.libelle" [siteId]="cell.row.data?.site?.id"></yo-site>
  </div>

  <div *dxTemplate="let cell of 'typeModeleTemplate'">
    {{ cell.row.data?.interne ? 'Interne' : 'Externe' }}
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} modèles de plats">
  </dxo-pager>

</dx-data-grid>


<p-overlayPanel #opDuplication>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group ">
        <label
          [class.requiredControl]="true"
          class="genlabel  font-16"
          title=""
        >Site sur lequel dupliquer le modèle</label>
        <div class="col-sm-10">
          <p-dropdown [options]="auth2Svc.utilisateur.siteListLocaux"
                      optionLabel="libelle"
                      filter="true"
                      [(ngModel)]="duplicationSiteSelected"
                      placeholder="sélection..."
                      [autoDisplayFirst]="false"
                      [style]="{'width':'360px'}">
            <ng-template let-site pTemplate="selectedItem">
                <span style="vertical-align:middle; margin-left: .5em">
                <yo-site [siteId]="site.id" [siteLibelle]="site.libelle"></yo-site></span>
            </ng-template>
            <ng-template let-site pTemplate="item">
              <div style="position: relative;height: 25px;">
                <div style="font-size:14px;margin-top:4px">
                  <yo-site [siteId]="site.id" [siteLibelle]="site.libelle"></yo-site>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 text-right">
      <yo-button
        label="Dupliquer"
        [theme]="ButtonThemeEnum.DEFAULT"
        iconClass="fas fa-copy"
        (onClick)="duplicateModele()">
      </yo-button>
    </div>
  </div>
</p-overlayPanel>

<!--PANEL EXPORT EXCEL-->
<p-overlayPanel #opExcel>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group ">
        <label
          [class.requiredControl]="true"
          class="genlabel  font-16"
          title=""
        >Nombre de modèles à exporter</label>
        <div class="col-sm-10">
          <p-dropdown [options]="exportOptionList"
                      optionLabel="libelle"
                      filter="true"
                      [(ngModel)]="selectExportOption"
                      placeholder="Sélection..."
                      [autoDisplayFirst]="false"
                      [style]="{'width':'180px'}">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

</p-overlayPanel>

<yo-parametre_calcul_conditionnement_global_dialog></yo-parametre_calcul_conditionnement_global_dialog>
